import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, Box, Typography } from "@mui/material";

const MetricCard = ({ title, value, icon }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Card
      sx={{
        border: "1px solid #E2E8F0",
        boxShadow: "none",
        borderRadius: "8px",
        height: "100%",
      }}
    >
      <CardContent sx={{ p: "14px !important" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Box
            sx={{
              bgcolor: "#F3F4F6",
              p: 1,
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#0070C2",
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>

          <Box sx={{ textAlign: isRTL ? "right" : "left", width: "100%" }}>
            <Typography
              sx={{
                fontSize: "12px",
                color: "#6B7280",
                fontWeight: 500,
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#111827",
                lineHeight: 1.2,
              }}
            >
              {value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
